<template>
  <section class="checkout mt-30">
    <Loader :visible="loading"></Loader>
    <div class="container">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <SummaryCheckout :loadingSummary="loadingCheckout" />
          <hr class="separate_hr" />
          <br />
          <div class="row">
            <div class="col-md-6">
              <InputForm
                v-model="order.name"
                :placeholder="$t('order.name')"
                v-validate="'required'"
                name="name" />
            </div>
            <div class="col-md-6">
              <InputForm
                v-model="order.middle_name"
                :placeholder="$t('order.middleName')"
                name="middle_name" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <InputForm
                v-model="order.last_name"
                :placeholder="$t('order.lastName')"
                v-validate="'required'"
                name="last_name" />
            </div>
            <div class="col-md-3">
              <InputForm
                v-model="order.phone"
                :placeholder="$t('order.phone')"
                v-validate="'required'"
                name="phone"
                v-mask="'############'" />
            </div>
            <div class="col-md-3" v-if="buyerField">
              <InputForm
                v-model="order.competitor_number"
                :placeholder="buyerFieldName"
                name="competitor_number" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <InputForm
                v-model="order.email"
                :placeholder="$t('order.email')"
                v-validate="'required|email'"
                name="email" />
            </div>
            <div class="col-md-6">
              <InputForm
                v-model="order.other_email"
                :placeholder="$t('order.otherEmail')"
                name="other_email" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <Textarea
                v-model="order.comments"
                :placeholder="$t('order.comments')"
                name="comments" />
            </div>
          </div>
          <div class="row">
            <hr class="separate_hr">
            <h3>{{$t("checkout.titlePayment")}}</h3>
            <div class="col-sm-6 col-md-6" v-for="method in paymentMethods" v-if="hasMethods" :key="method.name">
              <div class="payment-box">
                <div class="row">
                  <div class="col-sm-12 payment-method">
                    <input type="radio" :value="method.name" v-model="selectedMethod"/>
                    {{$t(`checkout.${method.name}`)}}
                    <img :src="method.image" />
                  </div>
                </div>
              </div>
            </div>
            <input ref="paymentMethod" :value="selectedMethod" class="d-none">
          </div>

          <div class="row" v-if="isCard">
            <div class="col-md-12">
              <InputForm
                v-model="card.name"
                :placeholder="$t('checkout.cardName')"
                v-validate="'required_if:paymentMethod,card'"
                name="titular" />
            </div>
            <div class="col-md-12">
              <InputForm
                v-model="card.number"
                :placeholder="$t('checkout.cardNumber')"
                v-validate="'required_if:paymentMethod,card'"
                v-mask="'####-####-####-####'"
                name="number" />
            </div>
            <div class="col-sm-6">
              <InputForm
                v-model="card.exp"
                :placeholder="$t('checkout.cardExp')"
                v-validate="'required_if:paymentMethod,card'"
                v-mask="'##/####'"
                name="exp" />
            </div>
            <div class="col-sm-6">
              <InputForm
                v-model="card.cvc"
                :placeholder="$t('checkout.cardCvc')"
                v-validate="'required_if:paymentMethod,card'"
                v-mask="'####'"
                name="cvc" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mt-40">
              <h3>{{$t("checkout.titlePrivacy")}}</h3>
              <div class="form-control privacy">
                <p v-html="privacy.htmlContent()"></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="custom-control custom-checkbox" >
                <label>
                  <input type="checkbox" class="custom-control-input" v-model="accepted" />
                  {{$t("checkout.acceptPrivacy")}}
                  <router-link to="/terms-conditions">
                    {{$t("checkout.acceptTerms")}}
                  </router-link>
                </label>
              </div>
              <div align="right" v-show="accepted">
                <!--router-link to="/successful"-->
                  <button class="button-cart" @click="purchase()">{{$t("checkout.buttonPay")}}</button>
              </div>
            </div>
          </div>

          <div class="row d-none">
            <form id="form-checkout" >
              <input type="text" name="cardNumber" id="form-checkout__cardNumber" :value="card.number" />
              <input type="text" name="cardExpirationMonth" id="form-checkout__cardExpirationMonth" :value="expMonth" />
              <input type="text" name="cardExpirationYear" id="form-checkout__cardExpirationYear" :value="expYear" />
              <input type="text" name="cardholderName" id="form-checkout__cardholderName" :value="card.name"/>
              <input type="email" name="cardholderEmail" id="form-checkout__cardholderEmail" :value="order.email"/>
              <input type="text" name="securityCode" id="form-checkout__securityCode" :value="card.cvc"/>
              <select name="identificationType" id="form-checkout__identificationType"></select>
              <select name="issuer" id="form-checkout__issuer"></select>
              <!--input type="text" name="identificationNumber" id="form-checkout__identificationNumber" :value="card.number"/-->
              <select name="installments" id="form-checkout__installments">
                <option value="1" selected>1</option>
              </select>
              <button type="submit" id="form-checkout__submit"></button>
            </form>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import Loader from "../../components/Loader"
import InputForm from "../../components/InputForm"
import Textarea from "../../components/Textarea"
import SummaryCheckout from "../../components/shopping_cart/SummaryCheckout"
import PageContent from "../../models/PageContent"
import cardImage from "../../images/shopping-cart/cards.png"
import paypalImage from "../../images/shopping-cart/paypal.png"
import oxxoImage from "../../images/shopping-cart/oxxo.png"
import {mask} from 'vue-the-mask'

export default {
  name: "Checkout",
  directives: {mask},
  components: {
    SummaryCheckout,
    PageContent,
    InputForm,
    Textarea,
    Loader
  },
  data() {
    return {
      privacy: new PageContent(),
      accepted: true,
      buyerField: false,
      buyerFieldName: "Competidor",
      selectedMethod: "",
      loading: true,
      total: 0,
      images: {
        "card": cardImage,
        "oxxo": oxxoImage,
        "paypal": paypalImage
      },
      paymentMethods: [],
      order: {
        name: "",
        middle_name: "",
        last_name: "",
        phone: "",
        email: "",
        other_email: "",
        competitor_number: "",
        comments: "",
        platform: "",
        kind: "card",
        metadata: {},
        currency_payment: "",
        currency_total: "",
        order_details_attributes: {}
      },
      card: {
        name: "",
        number: "",
        exp: "",
        cvc: ""
      }
    }
  },
  async created() {
    this.$root.$on("setShopingCart", this.setShopingCart)

    const content = await this.privacy.show("privacy")
    this.privacy = new PageContent(content)
    this.loading = false

    //this.setDefaultTest()
  },
  methods: {
    async loadingCheckout(state){
      this.loading = state
    },
    async purchase() {
      this.loading = true
      let valid = await this.isValid

      if(valid) {
        if(this.isCard) {
          if(this.isStripe) {
            const token = await this.validateCard()

            if(token) {
              this.createOrder(token, "Checkout.ThankYou")
            }
          } else if(this.isMercadoPago) {
            this.mercadoPagoToken()
          } else {
            this.conektaToken()
          }
        } else if(this.isPaypal) {
          this.createOrder({}, "Checkout.PaypalConfirm")
        } else if(this.isOxxo) {
          this.createOrder({}, "Checkout.PendingOxxo")
        }
      } else {
        this.loading = false
        this.$alertify.error(this.$t("checkout.missingParams"))
      }
    },
    async validateCard() {
      let card = this.card
      card.number = card.number.replace(/-/g, "")

      try {
        const response = await this.$http.post(`/api/v2/orders/validate_card`, {
          card: card
        })

        if(response.status == 200) {
          return response.data
        } else {
          return false
        }
      } catch(e) {
        this.loading = false
        this.$alertify.error(e.response.data.error.message)
        return false
      }
    },
    async mercadoPagoToken() {
      const cardForm = mecadoPago.cardForm({
        amount: this.total.toString(),
        autoMount: true,
        form: {
          id: "form-checkout",
          cardholderName: {
            id: "form-checkout__cardholderName"
          },
          cardholderEmail: {
            id: "form-checkout__cardholderEmail"
          },
          cardNumber: {
            id: "form-checkout__cardNumber"
          },
          cardExpirationMonth: {
            id: "form-checkout__cardExpirationMonth"
          },
          cardExpirationYear: {
            id: "form-checkout__cardExpirationYear"
          },
          securityCode: {
            id: "form-checkout__securityCode"
          },
          installments: {
            id: "form-checkout__installments"
          },
          issuer: {
            id: "form-checkout__issuer"
          },
        },
        callbacks: {
          onFormMounted: error => {
            if (error) return console.warn("Form Mounted handling error: ", error);
            document.getElementById("form-checkout__submit").click()
          },
          onSubmit: event => {
            event.preventDefault();
            const response = cardForm.getCardFormData();
            this.createOrder(response.token, "Checkout.ThankYou");
          }
        },
      });
    },
    async conektaToken() {
      let card = this.card,
        exp = card.exp.split("/")

      card.number = card.number.replace(/-/g, "")
      card.exp_month = exp[0]
      card.exp_year = exp[1]

      const payload = {card: card}

      Conekta.token.create(payload, this.sendConektaOrder, (error) => {
        this.$alertify.error(error.message)
        this.loading = false
      })
    },
    async sendConektaOrder(response) {
      this.createOrder(response, "Checkout.ThankYou")
    },
    async createOrder(token, routeName) {
      let order = this.order
      order.metadata = token

      try {
        const response = await this.$http.post(`/api/v2/orders`, {
          order: order
        })
        if(response.status == 200) {
          this.$router.push({
            name: routeName,
            params: {"order": response.data.order}}
          )
          this.loading = false
          return response.data
        } else {
          this.loading = false
          return false
        }
      } catch(e) {
        this.loading = false
        this.$alertify.error(e.response.data.error)
        return false
      }
    },
    setShopingCart(shoppingCart) {
      this.setPaymentMethods(shoppingCart.summary.payment_methods);
      this.buyerField = shoppingCart.summary.buyer_field;
      this.buyerFieldName = shoppingCart.summary.buyer_field_name;

      let items = shoppingCart.items.map(item => {
        return {
          kind: item.kind,
          event_id: item.event_id,
          concept_id: item.concept_id,
          photo: item.preview,
          quantity: item.quantity,
          price: item.price,
          discount: item.total_discount
        }
      });
      this.total = shoppingCart.total();
      this.order.order_details_attributes = items;
      this.order.currency_payment = shoppingCart.summary.currency_payment;
      this.order.currency_total = shoppingCart.summary.currency_total;
    },
    setPaymentMethods(paymentMethods) {
      this.paymentMethods = paymentMethods.map(method => {
        return {
          name: method.name,
          platform: method.platform,
          image: this.images[method.name]
        }
      })
      if(this.hasMethods) {
        this.selectedMethod = this.paymentMethods[0].name
      }
    },
    setDefaultTest() {
      this.order = {
        name: "Carlos",
        middle_name: "Diaz",
        last_name: "Melendez",
        phone: "3331290782",
        email: "carlos@chuspic.com",
        other_email: "",
        competitor_number: "1001",
        comments: "",
        platform: "mercadopago",
        kind: "card",
        metadata: {},
        order_details_attributes: {}
      }
      this.card = {
        name: "Carlos",
        //number: "4242-4242-4242-4242",
        number: "4189-1412-2126-7633",
        //number: "4000-0000-0000-0002",
        exp: "11/2025",
        cvc: "123"
      }
    }
  },
  computed: {
    isStripe() {
      return this.order.platform == "stripe"
    },
    isMercadoPago() {
      return this.order.platform == "mercadopago"
    },    
    isCard() {
      return this.selectedMethod == "card"
    },
    isPaypal() {
      return this.selectedMethod == "paypal"
    },
    isOxxo() {
      return this.selectedMethod == "oxxo"
    },
    async isValid() {
      return await this.$validator.validate().then(valid => {
        return valid
      })
    },
    hasMethods() {
      return this.paymentMethods.length > 0
    },
    expMonth() {
      if(this.card.exp.length > 0)
        return this.card.exp.split("/")[0]
      return ""
    },
    expYear() {
      if(this.card.exp.length > 0)
        return this.card.exp.split("/")[1]
      return ""
    }
  },
  watch: {
    selectedMethod(val, oldVal) {
      const payMethod = this.paymentMethods.find(item => item.name == val)

      if(val == "paypal") {
        this.order.platform = "paypal"
        this.order.kind = "sale"
      } else if (val == "card"){
        this.order.platform = payMethod.platform
        this.order.kind = val
      } else if (val == "oxxo"){
        this.order.platform = payMethod.platform
        this.order.kind = val
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  section.checkout {
    h3 {
      font-size: 22px;
    }

    p.description {
      font-family: $font-light;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #333333;
    }

    .payment-box {
      width: 100%;
      height: 50px;
      padding: 12px;
      background: #FFFFFF;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      input[type=radio] {
        margin-right: 5px;
      }
    }

    .privacy {
      overflow: scroll;
      height: 200px;
      padding: 30px;
      background: #E8EBED;
      opacity: 0.5;
      scrollbar-color: $secondary-base !important;

      p {
        color: #62707F;
        font-family: $font;
      }
    }

    .payment-method {
      position: relative;

      img {
        position: absolute;
        right: 17px;
        top: 17px;
      }
    }
  }
</style>
